<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>

          <modal-select modal="dsr-modal" name="dsr_id" :readonly="false" :item-id="item.dsr_id" :item-name="item.dsr?item.dsr.data.name:''" v-on:select-item="selectDsr"  :state="validateState('dsr_id')" placeholder="DSR" label="DSR" ></modal-select>


          <b-form-row>
            <b-col md="4">
              <b-form-group label="Pontos">
                <b-form-input type="number" step="1" min="0" name="points" v-model="item.points" placeholder="Pontos"  v-validate="'required'" :state="validateState('points')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('points') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Ano/Mês">
                <b-form-input type="number" step="1" min="0" name="ym" v-model="item.ym" placeholder="Ano/Mês"  v-validate="'required'" :state="validateState('ym')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('ym') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Razão">
                <b-form-input type="text"  name="reason" v-model="item.reason" placeholder="Razão"  v-validate="'required'" :state="validateState('reason')"></b-form-input>
                <b-form-invalid-feedback>
                  {{ errors.first('reason') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>
          </b-form-row>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'ola.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>
            {{ item }}
          </pre>

        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
export default {
  name: 'BestofDsrObjectiveEdit',
  props: ['id'],
  components: {},
  data() {
    return {
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        points: 0,
        dsr: {
          data: {
            name: '',
            id: null
          }
        },
        origin: '',
        origin_id: 0,
        suborigin: '',
        suborigin_id: 0
      }
    }
  },
  methods: {
    selectDsr(e) {
      if(e.item) {
        this.item.dsr_id = e.item.id
        this.item.dsr.data = e.item
      } else {
        this.item.dsr_id = null
        this.item.dsr.data = {id: null, name:null}
      }
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('ola' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            if (close) {
              this.$router.push({
                name: 'ola.index'
              })
            }
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      } else {
        this.axios.post('ola', data)
          .then(response => {
            this.item = response.data.data
            this.$bvToast.toast(`item gravado com sucesso`, { autoHideDelay: 5000, variant: 'success', solid: true })
            this.$router.push({
              name: 'ola.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('ola' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
          if(!this.item.dsr_id) {
            this.item.dsr = {
              data: {
                id: null,
                name: null,
              }
            }
          }
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'ola.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
